export default __webpack_public_path__ + "static/media/bus_redencao.2c362138.jpg";